import CryptoJS from 'crypto-js';

import { USUARIO_CONFIGS } from '@/shared/constants/strings';

export const USER_CONFIGS_KEY = import.meta.env.VITE_USER_CONFIGS_KEY as string;

export class UsuarioConfigs {
  username?: string;

  nome?: string;

  modulo?: number;

  cor_fundo_zebrado_tabela: string;

  cor_fonte_zebrado_tabela: string;

  navbar: boolean;
  cpf?: string

  static GetConfigs() {
    try {
      const encryptedData = localStorage.getItem(USUARIO_CONFIGS);
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, USER_CONFIGS_KEY);
        const configs = JSON.parse(
          bytes.toString(CryptoJS.enc.Utf8),
        ) as UsuarioConfigs;
        return configs;
      }
    } catch (error) {
      console.error('Erro ao descriptografar configurações:', error);
    }
    return null;
  }

  static SetConfigs(configs: UsuarioConfigs) {
    try {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(configs),
        USER_CONFIGS_KEY,
      ).toString();
      localStorage.setItem(USUARIO_CONFIGS, encrypted);
    } catch (error) {
      console.error('Erro ao criptografar configurações:', error);
    }
  }
}
